import React, { useCallback, useState } from "react";

//reactstrap
import {
  Row,
  Col,
  Button
} from "reactstrap";

//elements
import { ButtonEdit, ButtonDelete } from '@components-common/elements';

//DropdownFilter
import { DropdownAddUser, DropdownActions } from '../instructor/Users';

//common
import { DataEmty } from "@components-common";
import { ModalDeleteCommon } from "@ui-partents/Modal";

//react-bootstrap-table-next
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

//compponents
import {
  ModalInvite,
  ModalEditAccount,
  ModalImportExel,
} from "./Modal";
import { UserFilter } from '../instructor/Users';

//partents
import { SortCaret } from "@ui-partents/Table";

// Import the pagination configuration
import {paginationOptions} from "@utils";

//redux
import { useDispatch } from "react-redux";

import { atcAddUserAccount, atcRemoveUserAccount } from "@actions";

function TableLearners({ ...props }) {
  const dispatch = useDispatch();
  const resData = props?.data?.data;
  const listAcc = (resData && resData.Accounts) || [];
  const subscription = (resData && resData.Subscription) || {};
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [dataItem, setdataItem] = useState({});
  const [action, setAction] = useState("");
  const [modal, setModal] = useState({
    edit: false,
    delete: false,
    importExel: false,
    invite: false
  });

  const handleChange = (event) => {
    const { value } = event.target;
    if (value) {
      setSearchTerm(value);
    } else {
      setSearchResults(listAcc);
    }
  };

  const toggle = (data, type) => {
    setdataItem(data);
    setAction(type);
    setModal(prevState => ({ ...prevState, [type]: !prevState[type] }));
  };

  const handleChangeActions = (value) => {
    setModal((prevState) => ({ ...prevState, [value]: true }));
  };

  const filterDataByOptions = useCallback(() => {
    const data = resData && resData.Accounts;
    if (!searchTerm) {
      //reset Data
      setSearchResults(data);
    } else {
      //filter data
      const results =
        data &&
        data.filter(function (elem) {
          return elem.IsInstructor === searchTerm;
        });
      setSearchResults(results || data);
    }
  }, [searchTerm, resData]);

  const handleAdd = (data) => {
    const params = {
      Action: "Add",
      Email: data && data.Email,
    };
    dispatch(atcAddUserAccount(params));
    setModal((prevState) => ({ ...prevState, invite: false }));
  };

  const handleRemove = () => {
    const params = {
      Action: "Remove",
      Email: dataItem && dataItem.Email,
    };
    dispatch(atcRemoveUserAccount(params));
    setModal((prevState) => ({ ...prevState, delete: false }));
  };

  //Search
  React.useEffect(() => {
    filterDataByOptions();
  }, [filterDataByOptions]);

  const columns = [
    {
      dataField: "id",
      text: "ID",
      hidden: true
    },
    {
      dataField: "LastName",
      text: "Last Name",
      sort: true,
      sortCaret: (order, column) => <SortCaret order={order} />
    },
    {
      dataField: "FirstName",
      text: "First Name",
      sort: true,
      sortCaret: (order, column) => <SortCaret order={order} />
    },
    {
      dataField: "Email",
      text: "Email",
      sort: true,
      sortCaret: (order, column) => <SortCaret order={order} />
    },
    {
      dataField: "Role",
      text: "Role",
      classes: "align-middle text-center",
      sort: true,
      sortCaret: (order, column) => <SortCaret order={order} />,
      formatter: (cell, row) => {
        const checkClassByRole = (type) => {
          let className = ""
          switch (type) {
            case 'Admin':
              className = "text-danger";
              break;
            case 'Instructor':
              className = "text-info";
              break;
            default:
              className = "";
          }
          return className;
        }
        return <span className={`${checkClassByRole(row.Role)}`}>{row.Role}</span>;
      },
    },
    {
      dataField: "Status",
      text: "Status",
      classes: "align-middle text-center",
      formatter: (cell, row) => {
        return <span className={`${row.Status === 'Inactive' ? 'text-muted' : ''}`}>{row.Status}</span>;
      },
      sort: true,
      sortCaret: (order, column) => <SortCaret order={order} />,
    },
    {
      dataField: "Actions",
      text: "Actions",
      headerClasses: "text-center",
      style: {
        width: "100px",
      },
      formatter: (cell, row) => {
        return (
          <div className="d-flex algins-items-center justify-content-center">
            <ButtonEdit handleEdit={() => toggle(row, "edit")} />
            <ButtonDelete handleDelete={() => toggle(row, "delete")} />
          </div>
        );
      },
    },
  ];

  const { SearchBar } = Search;
  const selectRow = {
    mode: "checkbox"
  };

  const contentTable = ({ paginationProps, paginationTableProps }) => (
    <div>
      <ToolkitProvider
        keyField="Id"
        data={(searchResults && [...searchResults]) || []}
        columns={columns}
        search
      >
        {(toolkitprops) => (
          <>
            <Row className="justify-content-end mb-3">
              <Col md={6} sm={6} className="mb-3 mb-sm-0">
                <DropdownAddUser
                  handleChangeActions={handleChangeActions}
                />
                <DropdownActions />
              </Col>
              <Col md={6} sm={6}>
                <div className="boxSearch">
                  <SearchBar {...toolkitprops.searchProps} onSearch={(e) => {
                    paginationProps.page = 1
                    toolkitprops.searchProps.onSearch(e)
                  }}/>
                  <Button className="btnSearch" color="primary">
                    <i className="fa fa-search" aria-hidden="true"></i>
                  </Button>
                </div>
              </Col>
            </Row>
            <BootstrapTable
              condensed
              striped
              wrapperClasses="table-responsive checkBoxCustom"
              selectRow={selectRow}
              noDataIndication={() => (
                <div className="py-5">
                  <DataEmty content="No Data" />
                </div>
              )}
              {...paginationTableProps}
              {...toolkitprops.baseProps}
            />
          </>
        )}
      </ToolkitProvider>
      {/* /Table */}
      <div className="pagination-custom-case d-flex justify-content-center mt-4">
        <PaginationListStandalone {...paginationProps} />
      </div>
    </div>
  );

  const totalSize = searchResults?.length || 0; // Dynamically calculate the total size
  
  // Use the paginationOptions function to get the configuration
  const paginationConfig = paginationOptions({ totalSize });
  return (
    <React.Fragment>
      <ModalInvite
        isOpen={modal.invite}
        toggle={() => toggle({}, "invite")}
        handleAdd={handleAdd}
      />

      <ModalDeleteCommon
        title={`Are you sure you want to remove this account from your subscription?`}
        sub={`The account will no longer have access to the contents that are
                limited to your subscription`}
        isOpen={modal.delete}
        toggle={() => toggle(dataItem, "delete")}
        handleRemove={handleRemove}
      />
      <ModalEditAccount
        isOpen={modal.edit}
        toggle={() => toggle(dataItem, "edit")}
        data={dataItem}
        action={action}
      />
      <ModalImportExel
        isOpen={modal.importExel}
        toggle={() => toggle({}, "importExel")}
      />
      <Row className="mt-3">
        <UserFilter
          data={subscription}
          listAcc={(listAcc && listAcc) || []}
          handleChange={handleChange}
        />
        <Col md={9}>
          <div className="tableLearners">
            <PaginationProvider pagination={paginationFactory(paginationConfig)}>
              {contentTable}
            </PaginationProvider>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default TableLearners;
